module.exports = __webpack_public_path__ + "static/media/drakos2.53f24d6b.jpg";